function formatCurrency(amount) {
  const formatted = new Intl.NumberFormat('vi-VN', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount / 100);

  return `VND ${formatted}`;
}
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, showPopup = true) {
    // Debug
    console.log('Parsed State:', parsedState); 
    
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      if (parsedState.sections[section.id]) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    // Fetch lại giỏ hàng và cập nhật cart-notification-product-list
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      // Debugging
      console.log('Cart Data:', cart); 

      const cartListContainer = document.getElementById('cart-notification-product-list');
      const cartProductContainer = document.getElementById('cart-notification-product');

      // Xóa isEmpty
      if (cart.item_count > 0) {
        $(".cart-notification-product-container-item").removeClass("isEmpty");
      }

      // 1️ Xóa toàn bộ sản phẩm cũ trong danh sách
      cartListContainer.innerHTML = '';

      cart.items.forEach(item => {
        // 2️ Kiểm tra nếu sản phẩm đã có trong cart-notification-product thì bỏ qua
        if (item.key === this.cartItemKey) return;

          // 3️ Lấy Color, Size, và Properties
          const productOptions = item.options_with_values.map(option => `
            <div class="product-option">
              <dt>${option.name}:</dt>
              <dd>${option.value}</dd>
            </div>
          `).join('');

          const productProperties = Object.entries(item.properties || {})
          .filter(([key, value]) => value && !key.startsWith('_')) // Loại bỏ property rỗng và property ẩn
          .map(([key, value]) => `
            <div class="product-option">
              <dt>${key}:</dt>
              <dd>
                ${value.includes('/uploads/') 
                  ? `<a href="${value}" class="link" target="_blank">${value.split('/').pop()}</a>` 
                  : value}
              </dd>
            </div>
          `).join('');
        
        // 4 Tạo HTML và thêm vào danh sách
        const cartItemHTML = `
          <div class="cart-box-item" data-key="${item.key}">
            ${item.image ? `<div class="cart-notification-product__image global-media-settings">
              <img src="${item.image}" alt="${item.product_title}" width="77" height="80">
            </div>` : ''}
            <div class="cart-notification-product-info">
              <h3 class="cart-notification-product__name">${item.product_title}</h3>
              <div class="cart-notification-price-quantity">
                <p class="cart-notification-product__price">${formatCurrency(item.price)} </p>
                <p class="cart-notification-product__quantity">x${item.quantity}</p>
              </div>
              
              <dl>
                ${productOptions}
                ${productProperties}
              </dl>
            </div>
          </div>
        `;

        cartListContainer.insertAdjacentHTML('beforeend', cartItemHTML);
      });
      if (showPopup) {
        this.open();
      }
    });

    if (this.header) this.header.reveal();
    // this.open();

    setTimeout(() => {
      this.close();
    }, 3000);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-notification-product-list',
        selector: `#cart-notification-product-list`,
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
